import React, { ReactElement } from 'react';
import { Customer } from '../../models/customer';
import Frame from '../layouts/Frame';
import Stack from '../layouts/Stack';
import CustomerInfo from './CustomerInfo';

export interface CustomerInfoWithActionsProps {
  customer: Customer;
  onEditClick(): void;
  actions?: React.ReactNode[] | ((customer: Customer) => React.ReactNode[]);
  disableSchedule?: boolean;
}

export default function CustomerInfoWithActions({ customer, onEditClick, actions }: CustomerInfoWithActionsProps): ReactElement {

  return (
    <Frame horizontalPadding="middle" verticalPadding="small">
      <Stack vertical gap="middle">
        <CustomerInfo
          customer={customer}
          showEditButton
          onEditClick={onEditClick}
        />
        <Stack wrap gap={['middle', 'small']} horizontalAlign="space-between">
          {
            actions?.length
              ? (
                <Stack gap="small">
                  {
                    typeof actions === 'function'
                      ? actions(customer)
                      : actions
                  }
                </Stack>
              )
              : <div />
          }
        </Stack>
      </Stack>
    </Frame>
  );
}